import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { ChevronRight } from "lucide-react";

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

interface FAQProps {
  faqs?: FAQItem[];
  title?: string;
}

const defaultFAQs: FAQItem[] = [
  {
    id: "order-1",
    question:
      "Can I sell only a partial amount of my account and keep the remaining balance for future use?",
    answer: "Yes! We only use the amount of miles that we've agreed on.",
  },
  {
    id: "order-2",
    question: "Can I still use my account while you have access to it?",
    answer:
      "Yes! You remain in full control of the your account with all the functions. Please bear in mind not to use the miles/points that have been sold.",
  },
  {
    id: "order-3",
    question: "I know people with lots of miles. Can I make money from that?",
    answer:
      "Yes! We can pay you for every referral depending on the rewards and the amount. The Miles Market is a collective of people who love helping out other people. Please reach out!",
  },
  {
    id: "order-4",
    question: "Is the process of selling miles safe?",
    answer:
      "Absolutely, The whole transaction is secured with SSL back to back and we NEVER share your information with a 3rd party. Our effort helped The Miles Market become the safest and most secure place to Sell and buy miles in the industry.",
  },
  {
    id: "order-5",
    question: "What happens after I get paid?",
    answer:
      "You can withdraw the money and start using your cash immediately. We will take care of the rest. FAST SIMPLE AND SECURE",
  },
  {
    id: "order-6",
    question: "What if I continue to accumulate more miles in my account?",
    answer:
      "We will only use the amount of miles/points agreed on. If you'd like to sell more miles, please reach out and we'll be happy to make an offer!",
  },
  {
    id: "order-7",
    question: "When do I get paid?",
    answer: "Once we verify your miles/rewards you get paid within minutes.",
  },
];

export default function FAQ({
  title = "Frequently Asked Questions (FAQs)",
}: FAQProps) {
  const selectedFAQs = defaultFAQs;

  return (
    <div className="flex flex-col items-center py-20">
      <h2 className="text-[24px] md:text-[32px] px-14 md:px-0 font-semibold text-center">
        {title}
      </h2>
      <Accordion
        type="single"
        collapsible
        className="max-w-[800px] w-full py-[5%] px-4 md:px-0"
        defaultValue={selectedFAQs[0]?.id}
      >
        {selectedFAQs.map((faq) => (
          <AccordionItem key={faq.id} value={faq.id}>
            <AccordionTrigger className="text-[20px]">
              {faq.question}
            </AccordionTrigger>
            <AccordionContent className="text-[16px]">
              <p>{faq.answer}</p>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
      <button className="flex items-center justify-center gap-2 bg-[#ECFAFF] py-4 px-5 text-black rounded-4xl">
        Didn't find your answer? Contact us here
        <ChevronRight className="text-black pointer-events-none size-5" />
      </button>
    </div>
  );
}
